import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/production-stats', component: FuseLoadable({ loader: () => import('./ProductionStatsApp') }) }] };

export default [Index];
